import type { RouteLocationNormalized, RouteLocationRaw } from "vue-router";
import type { useAuthStore } from "@/stores/userAuth";

interface DashboardRoutingResult {
    redirect: boolean;
    route: RouteLocationRaw;
}

export function handleDashboardRouting(
    to: RouteLocationNormalized,
    authStore: ReturnType<typeof useAuthStore>
): DashboardRoutingResult {
    // If we're already on the correct dashboard for our user type, allow navigation
    if (
        (to.name === "Merchant of Record Dashboard" &&
            authStore.isMerchantOfRecord) ||
        (to.name === "Brand Dashboard" && authStore.isBrand) ||
        (to.name === "Supplier Dashboard" && authStore.isSupplier)
    ) {
        return { redirect: false, route: to.name };
    }

    // Otherwise redirect to the appropriate dashboard
    if (authStore.isMerchantOfRecord) {
        return {
            redirect: true,
            route: { name: "Merchant of Record Dashboard" },
        };
    }
    if (authStore.isBrand) {
        return { redirect: true, route: { name: "Brand Dashboard" } };
    }
    if (authStore.isSupplier) {
        return { redirect: true, route: { name: "Supplier Dashboard" } };
    }

    return { redirect: true, route: "/404" };
}
